<button *ngIf="user_id!=null" mat-raised-button (click)="navigateToWineCreate()" color="primary">
    Novo Vinho
</button>

<app-wine-read></app-wine-read>